module.exports = __webpack_public_path__ + "static/img/ap12.f7a4c29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ap12.jpg
// module id = h2O+
// module chunks = 1